(function() {
    'use strict';

    angular
        .module('quantixApp')
        .config(stateConfig);

        stateConfig.$inject = ['$stateProvider','$ocLazyLoadProvider'];

        function stateConfig($stateProvider,$ocLazyLoadProvider) {
            $ocLazyLoadProvider
            .config({
                'debug' : false, /*
                                     * for debugging ocLazyLoad module
                                     * 'true/false'
                                     */
                'events' : true, /*
                                     * for event ocLazyLoad module
                                     * 'true/false'
                                     */
                'modules' : [ {
                    name : 'CompanyReportDetailsModule', /*
                                         * injecting 
                                         * Module for ocLazyLoad
                                         */
                    /* files for lazy load */
                    files : [
                            'app/industry/industryBenchmark/industryHtmlgrid.controller.js',
                            'app/industry/industryBenchmark/industryBenchmarkGraph.js',
                            'app/industry/industryBenchmark/industryBenchmark.controller.js',
                            'app/services/industry/industryBenchmark/industryBenchmark.service.js',
                            'app/industry/industryBenchmark/industryFinanicalHtmlgrid.controller.js',
                            'app/industry/industryBenchmark/industryBenchmarkFinancialGraph.js',
                            'app/industry/industryBenchmark/listOfFinancialCompanies.modal.controller.js',
                            'app/industry/industryBenchmark/listOfCompanies.modal.controller.js',
                            'app/industry/industryBenchmark/comparedListOfCompanies.modal.controller.js',
                            'app/industry/industryBenchmark/directive/industryBenchmarkListOfCompanies.directive.js',
                            'app/industry/industryBenchmark/directive/industryBenchmarkListOfCompanies.controller.js',
                            'app/industry/industryBenchmark/directive/industryBenchmarkCompReport.controller.js',
                            'app/services/industry/industryBenchmark/translatorService.js',
                            'app/industry/smemargin/smemargin.controller.js']
                } ]
            });
        $stateProvider.state('companyreport', {
            parent: 'app',
            url: '/companyreport',
            data: {
                authorities: []
            }, views: {
                'content@': {
                    templateUrl: 'app/companyReport/companyreport.html',
                    controller: 'CompanyReportController',
                    controllerAs: 'vm'
                }
            }, resolve: {

                resolveView: ['GenericService', 'ErrorHandlerService','COMPANY_REPORT', '$state', 'Principal', function (GenericService, ErrorHandlerService, COMPANY_REPORT, $state, Principal) {
                    GenericService.getUserModuleAccessData().then(function(result){
                        if(result['COMPANY REPORT AXIS AMC']) {
                            Principal.identity().then(function(account){
                                if(account.isExternal =='Y'){
                                    $state.go('companyinforeport');
                                    return false;
                                }
                           });
                        }
                        if (result['COMPANY_INFO_REPORT2'] || result['COMPANY_INFO_REPORT1'] || result['COMPANY_INFO_REPORT3'] || result['COMPANY_INFO_REPORT_LITE_PLUS'] || result['COMPANY_INFO_REPORT_ADVANCED_PLUS'] || result['COMPANY_INFO_REPORT_COMPREHENSIVE_PLUS'] || result['COMPANY REPORT AXIS AMC']) {
                            return true;
                        } else {
                            ErrorHandlerService.forbiddenError('Company Information Report');
                            return false;
                        }
                    });
                }],
            }
            
        })
        $stateProvider.state('companyinforeport', {
            parent: 'app',
            url: '/companyinforeport',
            data: {
                authorities: []
            }, views: {
                'content@': {
                    templateUrl: 'app/companyReport/companyreportaxisamcext.html',
                    controller: 'CompanyReportAxisAmcExtController',
                    controllerAs: 'vm'
                }
            }, resolve: {

                resolveView: ['GenericService', 'ErrorHandlerService','COMPANY_REPORT', function (GenericService, ErrorHandlerService, COMPANY_REPORT) {
                    GenericService.getUserModuleAccessData().then(function(result){
                        if (result['COMPANY REPORT AXIS AMC']) {
                            return true;
                        } else {
                            ErrorHandlerService.forbiddenError('Company Information Report');
                            return false;
                        }
                    });
                }],
            }
            
        })
        .state('companyreportadmin', {
            parent: 'app',
            url: '/companyreportadmin',
            data: {
                authorities: []
            }, views: {
                'content@': {
                    templateUrl: 'app/companyReport/companyReportAdmin/companyreportadmin.html',
                    controller: 'CompanyReportAdminController',
                    controllerAs: 'vm'
                }
            }, resolve: {
                resolveView: ['GenericService', 'ErrorHandlerService','COMPANY_REPORT', 'AuthKeycloak',function (GenericService, ErrorHandlerService, COMPANY_REPORT, AuthKeycloak) {
                    if(AuthKeycloak.authz.hasRealmRole('ROLE_COMPANY_REPORT_ADMIN')) {
                        return true;
                    } else {
                        ErrorHandlerService.forbiddenError('Company Report Admin');
                        return false;
                    }
                }],
            }
            
        })
        .state('companyreportextadmin', {
            parent: 'app',
            url: '/companyreportextadmin',
            data: {
                authorities: []
            }, views: {
                'content@': {
                    templateUrl: 'app/companyReport/companyReportAdmin/companyreportextadmin.html',
                    controller: 'CompanyReportAdminController',
                    controllerAs: 'vm'
                }
            }, resolve: {
                resolveView: ['GenericService', 'ErrorHandlerService','COMPANY_REPORT', 'AuthKeycloak',function (GenericService, ErrorHandlerService, COMPANY_REPORT, AuthKeycloak) {
                    if(AuthKeycloak.authz.hasRealmRole('ROLE_COMPANY_REPORT_ADMIN')) {
                        return true;
                    } else {
                        ErrorHandlerService.forbiddenError('Company Report Admin');
                        return false;
                    }
                }],
            }
            
        })
         .state('teamdownloads', {
            parent: 'app',
            url: '/teamdownloads',
            data: {
                authorities: []
            }, views: {
                'content@': {
                    templateUrl: 'app/companyReport/companyReportTeamDownload/companyreportteamdownload.html',
                    controller: 'CompanyReportTeamDownloadController',
                    controllerAs: 'vm'
                }
            }, resolve: {

                resolveView: ['GenericService', 'ErrorHandlerService','COMPANY_REPORT', function (GenericService, ErrorHandlerService, COMPANY_REPORT) {
                    // GenericService.getUserModuleAccessData().then(function(result){
                    //     if (result['COMPANY_INFO_REPORT_LITE_PLUS'] || result['COMPANY_INFO_REPORT_ADVANCED_PLUS'] || result['COMPANY_INFO_REPORT_COMPREHENSIVE_PLUS']) {
                    //         return true;
                    //     } else {
                    //         ErrorHandlerService.forbiddenError('Company Information Report');
                    //         return false;
                    //     }
                    // });
                    return true;
                }],
            }
            
        })
        .state('teamdownloadsext', {
            parent: 'app',
            url: '/teamdownloadsext',
            data: {
                authorities: []
            }, views: {
                'content@': {
                    templateUrl: 'app/companyReport/companyReportTeamDownload/companyreportteamdownloadext.html',
                    controller: 'CompanyReportTeamDownloadControllerExt',
                    controllerAs: 'vm'
                }
            }, resolve: {

                resolveView: ['GenericService', 'ErrorHandlerService','COMPANY_REPORT', function (GenericService, ErrorHandlerService, COMPANY_REPORT) {
                    // GenericService.getUserModuleAccessData().then(function(result){
                    //     if (result['COMPANY_INFO_REPORT_LITE_PLUS'] || result['COMPANY_INFO_REPORT_ADVANCED_PLUS'] || result['COMPANY_INFO_REPORT_COMPREHENSIVE_PLUS']) {
                    //         return true;
                    //     } else {
                    //         ErrorHandlerService.forbiddenError('Company Information Report');
                    //         return false;
                    //     }
                    // });
                    return true;
                }],
            }
            
        })
        .state('managesubscriptions', {
            parent: 'app',
            url: '/managesubscriptions',
            data: {
                authorities: []
            }, views: {
                'content@': {
                    templateUrl: 'app/companyReport/companyReportClientAdmin/companyreportclientadmin.html',
                    controller: 'CompanyReportClientAdminController',
                    controllerAs: 'vm'
                }
            }, resolve: {

                resolveView: ['GenericService', 'ErrorHandlerService','COMPANY_REPORT','CompanyReportService', function (GenericService, ErrorHandlerService, COMPANY_REPORT, CompanyReportService) {
                    GenericService.getUserModuleAccessData().then(function(result){
                        if (result['COMPANY_INFO_REPORT2'] || result['COMPANY_INFO_REPORT1'] || result['COMPANY_INFO_REPORT3'] || result['COMPANY_INFO_REPORT_LITE_PLUS'] || result['COMPANY_INFO_REPORT_ADVANCED_PLUS'] || result['COMPANY_INFO_REPORT_COMPREHENSIVE_PLUS']) {
                            CompanyReportService.getCurrentUserType().then(function(success) {
                                if(success.data && success.data != null) {
                                    if(success.data.userType == 'Client Admin') {
                                        return true;
                                    } else {
                                        ErrorHandlerService.forbiddenError('Company Information Report');
                                        return false;
                                    }
                                } else {
                                    ErrorHandlerService.forbiddenError('Company Information Report');
                                    return false;
                                } }, function(error) {
                            })
                        } else {
                            ErrorHandlerService.forbiddenError('Company Information Report');
                            return false;
                        }
                    });
                    //return true;
                }],
            }
            
        })
        .state('setalert', {
            parent: 'app',
            url: '/setalert',
            data: {
                authorities: []
            }, views: {
                'content@': {
                    templateUrl: 'app/companyReport/companyReportAlerts/companyreportalert.html',
                    controller: 'CompanyReportAlertController',
                    controllerAs: 'vm'
                }
            }, resolve: {

                resolveView: ['GenericService', 'ErrorHandlerService','COMPANY_REPORT', function (GenericService, ErrorHandlerService, COMPANY_REPORT) {
                    GenericService.getUserModuleAccessData().then(function(result){
                        if (result['COMPANY_INFO_REPORT2'] || result['COMPANY_INFO_REPORT1'] || result['COMPANY_INFO_REPORT3'] || result['COMPANY_INFO_REPORT_LITE_PLUS'] || result['COMPANY_INFO_REPORT_ADVANCED_PLUS'] || result['COMPANY_INFO_REPORT_COMPREHENSIVE_PLUS']) {
                            return true;
                        } else {
                            ErrorHandlerService.forbiddenError('Company Information Report');
                            return false;
                        }
                    });
                }],
            }
            
        })
        .state('companyreportdetails', {
            parent: 'app',
            url: '/companyreportdetails',
            params: { // here we define default value for
                // financialadvantage
                // we also set squash to false, to force
                // injecting
                // even the default value into url
                companyDetails: {
                    value: undefined,
                },
                companyObj: {
                    value: undefined,
                },
                companyPeers: {
                    value: undefined,
                },
                remainigPeers: {
                    value: undefined,
                },
                industryLevel: {
                    value: undefined,
                },
                reportType: undefined,
                templateJson: {
                    value: undefined
                },
                fsmData: {
                    value: undefined,
                },
                isBobUser: {
                    value: undefined,
                },
                templateName: {
                    value: undefined,
                },
                // this param is not part of url
                // it could be passed with $state.go or ui-sref
                hiddenParam: 'YES'
            },
            data: {
                authorities: []
            }, views: {
                'content@': {
                    templateUrl: 'app/companyReport/companyReportDetails/companyreportdetails.html',
                    controller: 'CompanyReportDetailsController',
                    controllerAs: 'vm'
                }
            }, resolve: {
                loadMyCtrl : [
                    '$ocLazyLoad',
                    function($ocLazyLoad) {
                        return $ocLazyLoad
                                .load('CompanyReportDetailsModule'); /*
                                                     * Resolve
                                                     * promise
                                                     * and
                                                     * load
                                                     * before
                                                     * view
                                                     */
                    } ],
                resolveView: ['GenericService', 'ErrorHandlerService','COMPANY_REPORT', '$state', function (GenericService, ErrorHandlerService, COMPANY_REPORT, $state) {
                    return true;
                }],
            }
            
        })
        .state('newcompanyrequest', {
            parent: 'app',
            url: '/newcompanyrequest',
            data: {
                authorities: []
            }, views: {
                'content@': {
                    templateUrl: 'app/companyReport/newcompanyRequest/newcompanyrequest.html',
                    controller: 'NewCompanyRequestController',
                    controllerAs: 'vm'
                }
            }, resolve: {

                resolveView: ['GenericService', 'ErrorHandlerService','COMPANY_REPORT', function (GenericService, ErrorHandlerService, COMPANY_REPORT) {
                    GenericService.getUserModuleAccessData().then(function(result){
                        if (result['COMPANY_INFO_REPORT2'] || result['COMPANY_INFO_REPORT1'] || result['COMPANY_INFO_REPORT3'] || result['COMPANY_INFO_REPORT_LITE_PLUS'] || result['COMPANY_INFO_REPORT_ADVANCED_PLUS'] || result['COMPANY_INFO_REPORT_COMPREHENSIVE_PLUS']) {
                            return true;
                        } else {
                            ErrorHandlerService.forbiddenError('Company Information Report');
                            return false;
                        }
                    });
                }],
            }
            
        })
        .state('restrictiveaccess', {
            parent: 'app',
            url: '/restrictiveaccess',
            data: {
                authorities: []
            }, views: {
                'content@': {
                    templateUrl: 'app/companyReport/restrictiveaccess/restrictiveaccess.html',
                    controller: 'RestrictiveAccessController',
                    controllerAs: 'vm'
                }
            }, resolve: {

                resolveView: ['GenericService', 'ErrorHandlerService','COMPANY_REPORT','AuthKeycloak', function (GenericService, ErrorHandlerService, COMPANY_REPORT, AuthKeycloak) {
                    if(AuthKeycloak.authz.hasRealmRole('ROLE_COMPANY_REPORT_ADMIN')) {
                        return true;
                    } else {
                        ErrorHandlerService.forbiddenError('Restrictive Access');
                        return false;
                    }
                    // return true;
                }],
            }
            
        })
        .state('createnewtemplate', {
            parent: 'app',
            url: '/createnewtemplate',
            params: {
                templateJson: {
                    value: undefined,
                },
                createdOn:{
                    value: undefined,
                },
                action:{
                    value: undefined,
                },
                isAdminEdit: {
                    value: undefined
                },
                hiddenParam: 'YES'
            },
            data: {
                authorities: []
            }, views: {
                'content@': {
                    templateUrl: 'app/companyReport/customTemplate/customtemplatelevelone.html',
                    controller: 'CustomTemplateLevelOneController',
                    controllerAs: 'vm'
                }
            }, resolve: {

                resolveView: ['GenericService', 'ErrorHandlerService','COMPANY_REPORT', '$stateParams', function (GenericService, ErrorHandlerService, COMPANY_REPORT, $stateParams) {
                    GenericService.getUserModuleAccessData().then(function(result){
                        if (result['COMPANY_INFO_REPORT_LITE_PLUS'] || result['COMPANY_INFO_REPORT_ADVANCED_PLUS'] || result['COMPANY_INFO_REPORT_COMPREHENSIVE_PLUS']) {
                            return true;
                        } else {
                            if($stateParams.action == 'view') {
                                return true;
                            } else {
                                ErrorHandlerService.forbiddenError('Company Information Report');
                                return false;
                            }
                        }
                    });
                }],
            }
            
        })
        .state('mytemplates', {
            parent: 'app',
            url: '/mytemplates',
            params: {
                templateJson: {
                    value: undefined,
                },
                createdOn:{
                    value: undefined,
                },
                hiddenParam: 'YES'
            },
            data: {
                authorities: []
            }, views: {
                'content@': {
                    templateUrl: 'app/companyReport/customTemplate/mytemplates.html',
                    controller: 'MyTemplatesController',
                    controllerAs: 'vm'
                }
            }, resolve: {

                resolveView: ['GenericService', 'ErrorHandlerService','COMPANY_REPORT', function (GenericService, ErrorHandlerService, COMPANY_REPORT) {
                    // GenericService.getUserModuleAccessData().then(function(result){
                    //     if (result['COMPANY_INFO_REPORT_LITE_PLUS'] || result['COMPANY_INFO_REPORT_ADVANCED_PLUS'] || result['COMPANY_INFO_REPORT_COMPREHENSIVE_PLUS']) {
                    //         return true;
                    //     } else {
                    //         ErrorHandlerService.forbiddenError('Company Information Report');
                    //         return false;
                    //     }
                    // });
                    return true;
                }],
            }
            
        })
        .state('createcustomizedreport', {
            parent: 'app',
            url: '/createcustomizedreport',
            params: {
                templateJson: {
                    value: undefined,
                },
                originalJson: {
                    value: undefined,
                },
                createdOn:{
                    value: undefined,
                },
                action:{
                    value: undefined,
                },
                isAdminEdit: {
                    value: undefined
                },
                restrictions: {
                    value: undefined
                },
                hiddenParam: 'YES'
            },
            data: {
                authorities: []
            }, views: {
                'content@': {
                    templateUrl: 'app/companyReport/customTemplate/customtemplateleveltwo.html',
                    controller: 'CustomTemplateLevelTwoController',
                    controllerAs: 'vm'
                }
            }, resolve: {
                resolveView: ['GenericService', 'ErrorHandlerService','COMPANY_REPORT', '$stateParams', '$state', function (GenericService, ErrorHandlerService, COMPANY_REPORT, $stateParams, $state ) {
                    GenericService.getUserModuleAccessData().then(function(result){
                        if (result['COMPANY_INFO_REPORT_LITE_PLUS'] || result['COMPANY_INFO_REPORT_ADVANCED_PLUS'] || result['COMPANY_INFO_REPORT_COMPREHENSIVE_PLUS']) {
                            return $stateParams.templateJson ?  true : $state.go('createnewtemplate');
                        } else {
                            if($stateParams.action == 'view') {
                                return true;
                            } else {
                                ErrorHandlerService.forbiddenError('Company Information Report');
                                return false;
                            }
                        }
                    });
                }],
            }
            
        })
        $stateProvider.state('axisamcreportupload', {
            parent: 'app',
            url: '/axisamcreportupload',
            data: {
                authorities: []
            }, views: {
                'content@': {
                    templateUrl: 'app/companyReport/axisAmcReportUpload/axisamcreportupload.html',
                    controller: 'AxisAmcReportUploadController',
                    controllerAs: 'vm'
                }
            }, resolve: {

                resolveView: ['GenericService', 'ErrorHandlerService','COMPANY_REPORT', 'AuthKeycloak',function (GenericService, ErrorHandlerService, COMPANY_REPORT, AuthKeycloak) {
                    if(AuthKeycloak.authz.hasRealmRole('ROLE_COMPANY_REPORT_ADMIN')) {
                        return true;
                    } else {
                        ErrorHandlerService.forbiddenError('Report Upload');
                        return false;
                    }
                }],
            }
            
        })
        
    }
})();
